import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";

const MobileMenu = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [visibleSubmenu, setVisibleSubmenu] = useState(null);

  // Menu data (Main menu items)
  const whatWedoMenus = [
    { label: "Branded Merchandise", link: "/branded-merchandise" },
    { label: "Festive Gifting", link: "/festive-gifting" },
    { label: "Customized Gifts", link: "/customized-gifts" },
    { label: "Eco-Friendly Gifts", link: "/eco-friendly-gifts" },
    { label: "Employee Recognition", link: "/employee-recognition" },
    { label: "Company Store", link: "/company-store" },
  ];

  const whoWeareMenus = [
    { label: "Who We are", link: "/who-we-are/about-eyantra" },
    { label: "Responsibility", link: "/who-we-are/responsibility" },
  ];

  const catalogsMenus = [
    { label: "New year Catalog", link: "/catalog/new-year" },
    { label: "Diwali Catalog", link: "/catalog/diwali" },
    { label: "Other Brand Catalogs", link: "/catalog/other-brand-catalog" },
  ];

  const resourcesMenus = [
    { label: "Blogs", link: "/launching-soon" },
    { label: "Latest Blogs", link: "/launching-soon" },
  ];

  // Submenu data 
  const whatWedoSubmenus = [
    {
      ParentMenuLabel: "Branded Merchandise",
     
      solutions: [
        { solutionsLabel: "Corporate Gifting", SolutionLink: "/branded-merchandise/corporate-gifting" },
        { solutionsLabel: "Employee Gifts", SolutionLink: "/branded-merchandise/employee-gifts" },
        { solutionsLabel: "Event Gifts", SolutionLink: "/branded-merchandise/event-gifts" },
        { solutionsLabel: "Experiential Gifting", SolutionLink: "/branded-merchandise/experiential-gifting" },
      ]
    },
    {
      ParentMenuLabel: "Festive Gifting",
      solutions: [
        { solutionsLabel: "New Year Gifts", SolutionLink: "/festive-gifting/new-year-gifts" },
        { solutionsLabel: "Diwali Gifts", SolutionLink: "/festive-gifting/diwali-gifts" },
        { solutionsLabel: "Christmas Gifts", SolutionLink: "/festive-gifting/christmas-gifts" },
        { solutionsLabel: "Other Festive Gifts", SolutionLink: "/festive-gifting/other-festive-gifts" },
      ]
    },
    {
    ParentMenuLabel: "Customize Gifts",
    solutions:[
        {solutionsLabel:"Customized Gifts with Company Branding", SolutionLink:"/customized-gifts/customized-gifts-with-company-branding"},
        {solutionsLabel:"Customized Gifts without Company Branding", SolutionLink:"/customized-gifts/customized-gifts-without-company-branding"},
    ]
},
{
    ParentMenuLabel: "Eco-Friendly Gifts",
    solutions:[
          {solutionsLabel:"Eco-Friendly Gifts for Corporate Gifting", SolutionLink:"/eco-friendly-gifts/eco-friendly-gifts-for-corporate-gifting"},
          {solutionsLabel:"Eco-Friendly Gifts for Employees", SolutionLink:"/eco-friendly-gifts/eco-friendly-gifts-for-employees"},
          {solutionsLabel:"Eco-Friendly Gifts for Clients and Events", SolutionLink:"/eco-friendly-gifts/eco-friendly-gifts-for-clients-and-events"},
          {solutionsLabel:"Eco-Friendly Gifts for All Occasions", SolutionLink:"/eco-friendly-gifts/eco-friendly-gifts-for-all-occasions"},
    ]
},
{
    ParentMenuLabel: "Employee Recognition",
    solutions:[
        {solutionsLabel:"Joining Kits", SolutionLink:"/employee-recognition/joining-kits"},
        {solutionsLabel:"Welcome Kits", SolutionLink:"/employee-recognition/welcome-kits"},
        {solutionsLabel:"Rewards & Recognition (R&R)", SolutionLink:"/employee-recognition/reward-and-recognition"},
    ]
},
{
ParentMenuLabel: "Company Stores",
solutions:[
    {solutionsLabel:"Brand Store", SolutionLink:"/company-store/brand-store"},
    {solutionsLabel:"Office Supplies", SolutionLink:"/company-store/office-supplies"},
]
},
  ];
  const whoWeare = [
    {
      ParentMenuLabel: "About eYantra",
     
      solutions: [
        { solutionsLabel: "About eYantra", SolutionLink: "/who-we-are/about-eyantra" },
        { solutionsLabel: "responsibility", SolutionLink: "/who-we-are/responsibility" },
      ]
    },
  ];
  const catalog = [
    {
      ParentMenuLabel: "Catalogs",
     
      solutions: [
        { solutionsLabel: "New Year Catalog", SolutionLink: "/catalog/new-year" },
        { solutionsLabel: "Diwali Catalog", SolutionLink: "/catalog/diwali" },
        { solutionsLabel: "Other Brand Catalog", SolutionLink: "/catalog/other-brand-catalog" },
      ]
    },
  ];
  const Resources = [
    {
      ParentMenuLabel: "Resources",
     
      solutions: [
        { solutionsLabel: "Featured Blogs", SolutionLink: "/launching-soon" },
        { solutionsLabel: "Latest Blogs", SolutionLink: "/launching-soon" },
        // { solutionsLabel: "Careers", SolutionLink: "/launching-soon" },
      ]
    },
  ];

  // Combine all menus for easy iteration
  const allMenus = [
    { NormalText: "What we do", label: "Branded Merchandise", lableLink: "/branded-merchandise", submenus: whatWedoSubmenus, menus: whatWedoMenus },
    { label: "Festive Gifting", lableLink: "/festive-gifting", submenus: whatWedoSubmenus, menus: whatWedoMenus },
    { label: "Customize Gifts", lableLink: "/customized-gifts", submenus: whatWedoSubmenus, menus: whatWedoMenus },
    { label: "Eco-Friendly Gifts", lableLink: "/eco-friendly-gifts", submenus: whatWedoSubmenus, menus: whatWedoMenus },
    { label: "Employee Recognition", lableLink: "/employee-recognition", submenus: whatWedoSubmenus, menus: whatWedoMenus },
    { label: "Company Stores", lableLink: "/company-store", submenus: whatWedoSubmenus, menus: whatWedoMenus },

    { NormalText: "Who We are", label: "About eYantra", lableLink: "/who-we-are/about-eyantra", submenus: whoWeare, menus: whoWeareMenus },

    { label: "Our Work", lableLink: "/our-work", submenus: [], menus: catalogsMenus },
    { NormalText: "", label: "Catalogs", lableLink: "/", submenus: catalog, menus: catalog },

    { label: "Resources", lableLink: "/launching-soon", submenus: Resources, menus: resourcesMenus },
  ];

  // Handle mobile menu toggle
  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Handle submenu toggle for showing submenus
  const handleSubmenuClick = (menuLabel, event) => {
    event.stopPropagation(); 
    setVisibleSubmenu(visibleSubmenu === menuLabel ? null : menuLabel); 
  };

  // Handle menu item click to close mobile menu
  const handleMenuItemClick = () => {
    setIsMobileMenuOpen(false); 
  };

  return (
    <div className={`mobile-menu-container ${isMobileMenuOpen ? "open" : ""}`}>
      {/* Hamburger Menu Button */}
      <button
        className="navbar-toggler custom-toggler"
        type="button"
        onClick={handleMobileMenuToggle}
      >
        <Icon
          icon={isMobileMenuOpen ? "mdi:close" : "mdi:menu"} 
          width={30}
          height={30}
          className="m-1"
        />
      </button>

      {/* Mobile Menu Content */}
      <div className={`custom-collapse ${isMobileMenuOpen ? "open" : ""}`}>
        <a className="navbar-brand" id="mobileLogo" href="/">
          <img src="../assests/eyantra_logo.svg" alt="Eyantra Logo" loading="lazy"/>
        </a>
        <ul className="navbar-nav">
          {/* Loop through all main menus */}
          {allMenus.map((menu) => (
            <li key={menu.label} className="nav-item">
              {/* Display Parent Menu Label (NormalText) */}
              {menu.NormalText && <p className="menu-parent-label fw-bold p-0 m-0 texteYantra">{menu.NormalText}</p>}

              {/* Main Menu Item */}
              <div
                className="Menu"
                onClick={(event) => handleSubmenuClick(menu.label, event)}
              >
                <Link className="nav-link fw-bold text-black p-0 m-0" to="#">
                  <Link to={menu.lableLink} className="text-dark text-decoration-none" onClick={handleMenuItemClick}>
                    {menu.label}
                  </Link>
                  {menu.submenus.length > 0 && (
                    <Icon
                      icon={visibleSubmenu === menu.label ? "tabler:minus" : "tabler:plus"}
                      width="22"
                      height="22"
                      className="float-end"
                    />
                  )}
                </Link>
              </div>

              {/* Show submenus if applicable */}
              {visibleSubmenu === menu.label && menu.submenus.length > 0 && (
                <ul className="submenu">
                  {menu.submenus.map((submenuGroup) => (
                    <React.Fragment key={submenuGroup.ParentMenuLabel}>
                      {/* Only show submenus for the matching parent menu */}
                      {submenuGroup.ParentMenuLabel === menu.label && (
                        <ul className="submenu p-1">
                          {submenuGroup.solutions.map((submenuItem) => (
                            <li key={submenuItem.SolutionLink}>
                              <Link to={submenuItem.SolutionLink} className="text-dark text-decoration-none" onClick={handleMenuItemClick}>
                                {submenuItem.solutionsLabel}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </React.Fragment>
                  ))}
                </ul>
              )}
            </li>
          ))}

          {/* Contact Us Button */}
          <li className="nav-item">
            <button className="btn btn-primary" id="btnCTA">
              <Link className="nav-link fw-bold text-white p-0 m-0" to="/contact-us" onClick={handleMenuItemClick}>
                Contact Us
              </Link>
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default MobileMenu;
